import Box from '@mui/material/Box';
import Ranches from './Ranches';

const RanchesLayout: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: (theme) => theme.colors.canopy.background.default,
      }}
    >
      <Ranches />
    </Box>
  );
};

export default RanchesLayout;
